export default "__VITE_ASSET__DlSzdP3m__"